interface IconProps {
  svg: string;
  className?: string;
}
export const IconFromSVG = ({ svg, className }: IconProps) => {
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: svg }} />
  )
};
